import {useCallback} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

import type {TrustAccountViewTab} from '../utils';

export const useNavigateToTab = (): ((
  tab: TrustAccountViewTab,
  query?: Record<string, string>
) => void) => {
  const navigate = useNavigate();
  const {id} = useParams<{id: string}>();
  return useCallback(
    (tab: TrustAccountViewTab, query?: Record<string, string>) => {
      const search = query ? `?${new URLSearchParams(query).toString()}` : '';
      navigate(`/trust-accounts/${id}/${tab}${search}`);
    },
    [navigate, id]
  );
};
